import { Component } from '@angular/core';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {faSpinner} from '@fortawesome/free-solid-svg-icons/faSpinner';

@Component({
  selector: 'app-spinner',
  imports: [
    FaIconComponent
  ],
  templateUrl: './spinner.html',
  styleUrl: './spinner.css'
})
export class Spinner {

  protected readonly faSpinner = faSpinner;
}
